import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
    selector: "app-opposed-buttons-set",
    templateUrl: "./opposed-buttons-set.component.html",
    styleUrls: ["./opposed-buttons-set.component.scss"],
    standalone: false,
})
export class OpposedButtonsSetComponent {
    @Input() firstText: string = ""
    @Input() secondText: string = ""
    @Output() valueChange = new EventEmitter()
    allExpanded = false

    public updateButtonLabel() {
        this.allExpanded = !this.allExpanded
        this.valueChange.emit(this.allExpanded)
        if (!this.allExpanded) {
            let elem = document.getElementById("resource-standards-tab")
            elem.scrollIntoView()
        }
    }
}
